var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSkypeFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#3284FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4231 18.0676C38.1005 16.8681 37.1547 15.9225 35.9553 15.5995C33.7642 15 24.9997 15 24.9997 15C24.9997 15 16.2355 15 14.0444 15.5768C12.8681 15.8995 11.8993 16.8683 11.5766 18.0676C11 20.2585 11 24.8023 11 24.8023C11 24.8023 11 29.3689 11.5766 31.5369C11.8996 32.7362 12.845 33.6819 14.0446 34.0048C16.2585 34.6045 25 34.6045 25 34.6045C25 34.6045 33.7642 34.6045 35.9553 34.0277C37.1549 33.7049 38.1005 32.7593 38.4234 31.5599C38.9999 29.3688 38.9999 24.8253 38.9999 24.8253C38.9999 24.8253 39.0229 20.2585 38.4231 18.0676ZM22.2092 28.9999V20.6046L29.4974 24.8022L22.2092 28.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSkypeFooter);
export default __webpack_public_path__ + "static/media/ic-skype_footer.4c23490023f49f87087ac5e2431e373c.svg";
export { ForwardRef as ReactComponent };